import { ActionTypes as actions } from '../actions';

const initialState = {
  practice: null,
  info: null,
  userRoles: null,
  locations: null,
  joinRequests: null,
  editLocationInfo: null,
  patients: null,
  staff: null,
  frontDeskUsers: null,
  frontDeskTasks: null,
  clients: null,
  selectedStaffMember: null,
  selectedStaffMemberRoles: null,
  selectedStaffMemberLocations: null,
  selectedLocation: null,
  selectedFrontDeskLocation: null,
  selectedUnassignedClient: null,
  notificationPreferences: null,
  providerLocations: null,
  bank: null,
  stripeAccount: null,
  stripeVerificationLink: null,
  stripeUpdateLink: null,
  alerts: null,
  clientsPageState: null,
  providersPageState: null,
  practiceSubscription: null,
}

export default function PracticeReducer(state=initialState, action) {

  switch(action.type) {
    case actions.PRACTICE_UPDATE_PRACTICE:
      state = { ...state, practice: action.payload };
      break;
    case actions.PRACTICE_JOIN_REQUESTS_UPDATE:
      state = { ...state, joinRequests: action.payload };
      break;
    case actions.PRACTICE_USER_ROLE_ADD:
      var updatedUserRoles = state.userRoles ? Object.assign({}, state.userRoles) : {};
      const userRoleToAdd = action.payload;
      updatedUserRoles[userRoleToAdd.user_id] = userRoleToAdd;
      state = { ...state, userRoles: updatedUserRoles }
      break;
    case actions.PRACTICE_USER_ROLE_UPDATE:
      state = { ...state, userRoles: action.payload }
      break;
    case actions.PRACTICE_ADD_PATIENT:
      var updatedPatients = state.patients ? Object.assign({}, state.patients) : {};
      var patientToAdd = action.payload;
      updatedPatients[patientToAdd._id] = patientToAdd;
      state = { ...state, patients: updatedPatients }
      break;
    case actions.PRACTICE_PATIENTS_UPDATE:
      state = { ...state, patients: action.payload }
      break;
    case actions.PRACTICE_LOCATIONS_UPDATE:
      state = { ...state, locations: action.payload };
      break;
    case actions.PRACTICE_INFO_UPDATE:
      state= { ...state, info: action.payload };
      break;
    case actions.PRACTICE_EDIT_LOCATION_UPDATE:
      state= { ...state, editLocationInfo: action.payload };
      break;
    case actions.PRACTICE_LOCATION_ADD:
      var updatedLocations = state.locations ? Object.assign({}, state.locations) : {};
      const locationToAdd = action.payload;
      updatedLocations[locationToAdd._id] = locationToAdd;
      state = { ...state, locations: updatedLocations }
      break;
    case actions.PRACTICE_LOCATION_MEMBERS_ADD:
      const membersInfo = action.payload;
      var practiceToAddTo = state.locations[membersInfo.location_id];
      if (practiceToAddTo) {
        practiceToAddTo.members = membersInfo.members;
        state.locations[membersInfo.location_id] = practiceToAddTo;
      }
      state = { ...state, locations: state.locations };
      break;
    case actions.PRACTICE_LOCATIONS_DETAILS_SELECT:
      state = { ...state, selectedLocation: action.payload };
      break;
    case actions.PRACTICE_PROVIDER_LOCATION_DICT_ADD:
      let updatedProviderLocations = state.providerLocations ? Object.assign({}, state.providerLocations) : {};
      let providerLocationToAdd    = action.payload;
      let location_object          = updatedProviderLocations[providerLocationToAdd.location_id] || {};
      location_object[providerLocationToAdd.user_id] = true;
      updatedProviderLocations[providerLocationToAdd.location_id] = location_object;
      state = { ...state, providerLocations: updatedProviderLocations }
      break;
    case actions.PRACTICE_STAFF_UPDATE:
      state= { ...state, staff: action.payload };
      break;
    case actions.PRACTICE_STAFF_MEMBER_SELECTED_UPDATE:
      state= { ...state, selectedStaffMember: action.payload };
      break;
    case actions.PRACTICE_STAFF_MEMBER_SELECTED_ROLES_UPDATE:
      state= { ...state, selectedStaffMemberRoles: action.payload }
      break;
    case actions.PRACTICE_STAFF_MEMBER_SELECTED_LOCATIONS_UPDATE:
      state= { ...state, selectedStaffMemberLocations: action.payload }
      break;
    case actions.PRACTICE_CLIENTS_UPDATE:
      state= { ...state, clients: action.payload };
      break;
    case actions.PRACTICE_SELECTED_UNASSIGNED_CLIENT:
      state= { ...state, selectedUnassignedClient: action.payload };
      break;
    case actions.PRACTICE_FRONT_DESK_SELECT:
      state = { ...state, selectedFrontDeskLocation: action.payload }
      break;
    case actions.PRACTICE_FRONT_DESK_USERS_UPDATE:
      state = { ...state, frontDeskUsers: action.payload }
      break;
    case actions.PRACTICE_FRONT_DESK_TASKS_UPDATE:
      state = { ...state, frontDeskTasks: action.payload }
      break;
    case actions.PRACTICE_UPDATE_BANK:
      state= { ...state, bank: action.payload }
      break;
    case actions.PRACTICE_UPDATE_STRIPE:
      state= { ...state, stripeAccount: action.payload }
      break;
    case actions.PRACTICE_UPDATE_STRIPE_VERIFICATION_LINK:
      state= { ...state, stripeVerificationLink: action.payload }
      break;
    case actions.PRACTICE_UPDATE_STRIPE_UPDATE_LINK:
      state= { ...state, stripeUpdateLink: action.payload }
      break;
    case actions.PRACTICE_UPDATE_ALERTS:
      state= { ...state, alerts: action.payload }
      break;
    case actions.PRACTICE_UPDATE_NOTIFICATION_PREFERENCES:
      state= { ...state, notificationPreferences: action.payload }
      break;
    case actions.PRACTICE_PROVIDER_LOCATION_DICT_UPDATE:
      state= { ...state, providerLocations: action.payload }
      break;
    case actions.PRACTICE_CLIENT_PAGE_STATE_UPDATE:
      state = { ...state, clientsPageState: action.payload }
      break;
    case actions.PRACTICE_PROVIDER_PAGE_STATE_UPDATE:
      state = { ...state, providersPageState: action.payload }
      break;
    case actions.PRACTICE_UPDATE_PRACTICE_SUBSCRIPTION:
      state = { ...state, practiceSubscription: action.payload }
      break;
    case actions.USER_SIGN_OUT:
      state = initialState;
      break;
    default:

  }

  return state;
}
